export default function Dashboard() {
  return <h3 className='text-center p-3'>Dashboard 子路由（1） 内容</h3>;
}
